export enum PraticaSection {
  APPLICANT = 'applicant',
  ANAGRAPHICS = 'anagraphics',
  REQUESTS = 'requests',
  SCORE = 'score',
  PRESENTATION_SHEET = 'presentation-sheet',
  DOCUMENTS = 'documents',
}
